import IReporter from '../interfaces/IReporter';
import IReportingEvent from '../interfaces/IReportingEvent';
import Reporter from './Reporter';

export default class ScriptReporter extends Reporter implements IReporter {
    async sendReport(event: IReportingEvent): Promise<void> {
        try {
            super.sendThirdPartyReport(event.type);
            // eslint-disable-next-line no-param-reassign
            event = super.getMappedParams(event);

            const reportingUrl = this.config.url;
            const joiner = (reportingUrl.indexOf('?') > -1) ? '&' : '?';
            const params = this.buildParameterQueryParams(event);

            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.async = true;
            script.src = reportingUrl + joiner + params;

            document.getElementsByTagName('head')[0].appendChild(script);
            // @ts-ignore
            return;
        } catch (err) {
            throw err;
        }
    }

    private buildParameterQueryParams(event: IReportingEvent): string {
        if (!event) {
            return '';
        }
        return Object.keys(event).map((key) => `${key}=${event[key]}`).join('&');
    }
}
